import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Video, Users, TrendingUp } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Home() {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    candidate_name: "",
    candidate_email: "",
    position: "",
  });
  const [loading, setLoading] = useState(false);

  const handleStartInterview = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/interviews`, formData);
      const interviewId = response.data.id;
      navigate(`/interview/${interviewId}`);
    } catch (error) {
      console.error("Error starting interview:", error);
      alert("Failed to start interview. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hero-section" data-testid="home-page">
      <div className="hero-content">
        <h1 className="hero-title" data-testid="hero-title">
          RASPRO UNIVERSE
        </h1>
        <p className="hero-subtitle" data-testid="hero-subtitle">
          Analisis ekspresi wajah, evaluasi intonasi suara, dan penilaian konten
          yang canggih didukung oleh Gemini AI. Transformasi proses rekrutmen Anda
          dengan otomasi cerdas.
        </p>

        <div className="hero-buttons">
          <button
            className="btn btn-primary"
            onClick={() => setShowForm(true)}
            data-testid="start-interview-btn"
          >
            <Video size={20} />
            Mulai Interview
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => navigate("/admin")}
            data-testid="admin-dashboard-btn"
          >
            <Users size={20} />
            Dashboard Admin
          </button>
        </div>

        <div className="stats-grid" style={{ marginTop: "4rem" }}>
          <div className="stat-card">
            <Video size={40} color="#0891b2" style={{ marginBottom: "1rem" }} />
            <h3 style={{ fontSize: "1.2rem", marginBottom: "0.5rem" }}>
              Analisis Real-time
            </h3>
            <p style={{ color: "#64748b" }}>
              Pelacakan ekspresi wajah dan intonasi suara secara langsung selama interview
            </p>
          </div>
          <div className="stat-card">
            <TrendingUp size={40} color="#0891b2" style={{ marginBottom: "1rem" }} />
            <h3 style={{ fontSize: "1.2rem", marginBottom: "0.5rem" }}>
              Penilaian AI
            </h3>
            <p style={{ color: "#64748b" }}>
              Evaluasi otomatis dengan metrik kinerja yang detail
            </p>
          </div>
          <div className="stat-card">
            <Users size={40} color="#0891b2" style={{ marginBottom: "1rem" }} />
            <h3 style={{ fontSize: "1.2rem", marginBottom: "0.5rem" }}>
              Laporan Cerdas
            </h3>
            <p style={{ color: "#64748b" }}>
              Wawasan komprehensif dan rekomendasi untuk keputusan perekrutan
            </p>
          </div>
        </div>
      </div>

      {showForm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "2rem",
          }}
          data-testid="interview-form-modal"
          onClick={(e) => {
            if (e.target === e.currentTarget) setShowForm(false);
          }}
        >
          <div
            style={{
              background: "white",
              padding: "2.5rem",
              borderRadius: "20px",
              maxWidth: "500px",
              width: "100%",
              boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2
              style={{
                fontSize: "1.8rem",
                marginBottom: "1.5rem",
                color: "#0891b2",
              }}
            >
              Mulai Interview Anda
            </h2>
            <form onSubmit={handleStartInterview}>
              <div className="form-group">
                <label className="form-label">Nama Lengkap</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Nama Anda"
                  value={formData.candidate_name}
                  onChange={(e) =>
                    setFormData({ ...formData, candidate_name: e.target.value })
                  }
                  required
                  data-testid="candidate-name-input"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-input"
                  placeholder="email@example.com"
                  value={formData.candidate_email}
                  onChange={(e) =>
                    setFormData({ ...formData, candidate_email: e.target.value })
                  }
                  required
                  data-testid="candidate-email-input"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Posisi</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Software Engineer"
                  value={formData.position}
                  onChange={(e) =>
                    setFormData({ ...formData, position: e.target.value })
                  }
                  required
                  data-testid="position-input"
                />
              </div>
              <div style={{ display: "flex", gap: "1rem", marginTop: "2rem" }}>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ flex: 1 }}
                  disabled={loading}
                  data-testid="submit-interview-btn"
                >
                  {loading ? "Memulai..." : "Mulai Interview"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowForm(false)}
                  disabled={loading}
                  data-testid="cancel-form-btn"
                >
                  Batal
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
